export default "__VITE_ASSET__3b99dcab__"